import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule, Routes } from '@angular/router';
import { DialogModule } from 'primeng/primeng';
import { AuthGuard } from '../guards/auth.guard';
import { PrismDataSource } from '../models/prism-data-source.model';
import { ReconApiService } from '../services/recon-api.service';
import { DepositSettingsComponent } from './components/deposit-settings.component';
import { SettingsComponent } from './settings.component';

const moduleroutes: Routes = [
    {
        path: 'settings',
        component: SettingsComponent,
        children: [
            { path: 'deposit', component: DepositSettingsComponent, canActivate: [AuthGuard] },
        ],
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(moduleroutes),
        CommonModule,
        DialogModule,
    ],
    declarations: [
        DepositSettingsComponent,
    ],
    providers: [
        ReconApiService,
    ],
})
export class SettingsModule {
}



// WEBPACK FOOTER //
// ./src/app/settings/settings.module.ts